import { type AccountData, isNotEmpty, type UserId } from '@terros/common'
import { type ActivityAccess } from './activityAccess'

type LegacyActivityAccountProps = {
  account: AccountData
  access: ActivityAccess
  viewerId: UserId
}

/** Without ownership dates, only show the current owner's own contributions, never inferred ownership. */
export const toLegacyActivityAccount = ({ account, access, viewerId }: LegacyActivityAccountProps): AccountData => {
  if (access !== 'ownStretches' || isNotEmpty(account.ownerHistory)) return account
  return {
    ...account,
    workflowHistory: account.workflowHistory?.filter((item) => item.userId === viewerId),
    notes: account.notes?.filter((note) => note.userId === viewerId),
    ownerHistory: [],
    closerHistory: [],
    teamHistory: [],
    // A filtered audit list would falsely identify the viewer's first save as account creation.
    modifiedBy: [],
  }
}
